// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__NKp0q","aboutTextBox":"About_aboutTextBox__cr42u","aboutImageBox":"About_aboutImageBox__y+NRQ","aboutImg":"About_aboutImg__+jyy6"};